//------------------------------------------------------ externos
import { useState, useEffect } from "react";
//------------------------------------------------------ elementos
import CardLogo from "../../components/cards/CardLogo";
//------------------------------------------------------ funciones
import { columnas } from "../../components/modales/data/Columnas";
import Modal from "../modales/Modal";
import { capitalizarTexto } from "../../functions/dataFunctions";

const RegistroAccess = ({
  filtro = null,
  title = null,
  data = [],
  filtroParaForm = null,
  editable = true,
}) => {
  const TITLE = title
    ? capitalizarTexto(title)
    : filtro
      ? capitalizarTexto(filtro)
      : "Eventos";
  const COLECCION = filtro ? filtro : "eventos";
  const [listado, setListado] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const headers = columnas["eventos"];

  useEffect(() => {
    setListado(data);
  }, [data]);

  const handleOpen = () => {
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <CardLogo
        icono="lista"
        title={TITLE}
        onClick={() => handleOpen()}
        onClose={() => handleClose()}
      />
      {modalVisible && headers.length > 0 && (
        <Modal
          title={TITLE}
          coleccion={COLECCION}
          data={listado}
          headers={headers}
          filtroParaForm={filtroParaForm}
          onClose={() => handleClose()}
          editable={editable}
        />
      )}
    </>
  );
};

export default RegistroAccess;
